import { createCreateFetchingKey } from "@multiweb/reactUtils";

/**
 * Jméno modulu auth. Slouží pro jednoznačnou identifikaci modulu.
 */
export const NAME = "auth";

/**
 * Klíč pro indikaci načítání uživatele v fetching modulu.
 */
export const FETCHING_KEY_USER = createCreateFetchingKey(NAME)("user");
